import { Component, Input, OnInit } from '@angular/core';
import {
  EnterpriseBasketService,
  ServiceType,
  ParkingQuote,
  EnterpriseSearchService,
  UserService,
  ModalOpenerService
} from '@sabstravtech/obtservices/angular';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

import { resultIcons } from '../../../../core/enum/result-icons.enum';
import { ParkingComponent } from '../parking.component';
import { ThemeService } from '../../../../core/services/theme.service';
import { LightningModalTypes } from '../../../../core/classes/modal-types.enum';

@Component({
  selector: 'app-parking-list-view',
  templateUrl: './parking-list-view.component.html',
  styleUrls: ['./parking-list-view.component.scss'],
  standalone: false
})
export class ParkingListViewComponent extends ParkingComponent implements OnInit {
  @Input() data: any;
  @Input() canOveride = false;
  resultItemType = resultIcons;
  displayItinerary = false;
  constructor(
    searchService: EnterpriseSearchService,
    userService: UserService,
    route: ActivatedRoute,
    basketService: EnterpriseBasketService,
    translateService: TranslateService,
    title: Title,
    themeService: ThemeService,
    modalService: ModalOpenerService,
    router: Router
  ) {
    super(
      searchService,
      userService,
      route,
      basketService,
      translateService,
      title,
      themeService,
      modalService,
      router
    );
  }

  ngOnInit(): void {
    this.displayItinerary = this.userService.isBasketReplacementUserFavouriteSet();
  }

  getLogoAltText(item: any): string {
    const filters = this.getParkingFilters(item.carPark);
    const info = filters.join(', ');

    return info ? `${item.carPark.name} '${info}' logo` : `${item.carPark.name} logo`;
  }

  private getParkingFilters(carPark: any): string[] {
    if (!carPark) {
      return [];
    }

    return [
      carPark.carParkedForYou ? 'Car parked for you' : 'Self Park',
      carPark.meetAndGreet && 'Meet and greet',
      carPark.onAirport && 'On airport'
    ].filter(Boolean);
  }

  viewMapPage(item: ParkingQuote, itemIndex: number) {
    (this.searchService as any).lastFocusedParkingIndex = itemIndex;
    this.searchService.searches[ServiceType.Parking].listViewToggle.next(item);
  }

  openParkingDetails(item: ParkingQuote) {
    this.modalService.open(
      LightningModalTypes.ModalParkingDetailsComponent,
      {
        centered: true
      },
      {
        item: item
      }
    );
  }
}
